import React from 'react';

const CommonInvite = (props) => {
    return (
        <div className="u_register-view">
            <h2 className="u_t-center">{props.heading}</h2>
            <p className={`u_register-title u_t-center ${props.error ? 'u_pb-15' : 'u_pb-30'}`}>{props.title}</p>
            {props.error && <p className="u_error-message u_t-center u_pb-15">{props.error}</p>}
        </div>
    );
};

export default CommonInvite;